import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import './i18n';

import {Provider } from 'react-redux';
import store from './store';


import './index.css';
import './bootstrap.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from 'react-bootstrap';
import axios from 'axios';
import { detectMarket, getCurrencyForMarket } from './utils/market';

const PAYPAL_CONFIG_STORAGE_KEY = 'paypalConfig_v3';

const getInitialPayPalOptions = () => {
  try {
    const cached = localStorage.getItem(PAYPAL_CONFIG_STORAGE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (parsed?.clientId) {
        return parsed;
      }
    }
  } catch (error) {
    // Ignore cache parsing issues and fall back to default
  }

  const market = detectMarket();

  return {
    clientId: 'test',
    currency: getCurrencyForMarket(market),
    intent: 'capture',
    components: 'buttons',
  };
};

function Root() {
  const [paypalOptions, setPaypalOptions] = useState(getInitialPayPalOptions());

  useEffect(() => {
    // Fetch PayPal configuration from backend
    const fetchPayPalConfig = async () => {
      try {
        const market = detectMarket();
        const { data } = await axios.get(`/api/payments/config/paypal/?market=${encodeURIComponent(market)}`);
        // Only update if we received a valid (non-empty) client ID.
        // An empty client ID from an unconfigured backend would break the SDK.
        if (data.clientId) {
          const nextOptions = {
            clientId: data.clientId,
            currency: data.currency || getCurrencyForMarket(market),
            intent: "capture",
            components: "buttons",
          };
          setPaypalOptions(nextOptions);
          localStorage.setItem(PAYPAL_CONFIG_STORAGE_KEY, JSON.stringify(nextOptions));
        }
      } catch (error) {
        console.error('Failed to load PayPal configuration:', error);
      }
    };

    fetchPayPalConfig();
  }, []);

  return (
    <Provider store={store}>
      <PayPalScriptProvider options={paypalOptions}>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </PayPalScriptProvider>
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Root />);

reportWebVitals();
